const Types = {
  SET_IS_USER_VIEWER_REDATOR: '@session/SET_IS_USER_VIEWER_REDATOR',
  SET_IS_VIEWER_REDATOR: '@session/SET_IS_VIEWER_REDATOR',
  SET_IS_VIEWER: '@session/SET_IS_VIEWER',
  SET_IS_REDATOR: '@session/SET_IS_REDATOR',
};

export default Types;
